// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/rating/style/index.less
// module id = 121
// module chunks = 0